<template>
  <button
    class="btn ms-auto"
    :class="classes"
    :disabled="working"
    @click.prevent="publish"
  >
    <span v-if="working">...</span>
    <span v-if="!working">
      {{ published == 1 ? unpublishText : publishText }}
    </span>
  </button>
</template>

<script>
export default {
  props: [
    'route',
    'isPublished',
    'publishText',
    'unpublishText',
    'additionalClasses',
  ],
  data() {
    return {
      published: null,
      working: false,
    }
  },
  mounted() {
    this.published = this.isPublished
  },
  computed: {
    classes() {
      let result = ''

      if (this.published == 1) {
        result += 'btn-outline-danger '
      } else {
        result += 'btn-outline-primary '
      }
      result += `${this.additionalClasses} `

      return result
    },
  },
  methods: {
    handleError() {
      iziToast.error({
        title: 'Error',
        message: this.$t('Something went wrong'),
        position: 'bottomLeft',
      })
    },
    publish() {
      this.working = true
      axios
        .patch(this.route)
        .then(response => {
          this.published = response.data.is_published
          this.working = false
        })
        .catch(e => {
          if (e.response && e.response.status === 419) {
            this.$root.$emit(
              'flash',
              this.$t('Your session has expired - please reload'),
              'warning'
            )
          } else {
              this.handleError()
            }
        })
    },
  },
}
</script>
